module.exports = __webpack_public_path__ + "8c40884fab2d17faade26e68c835423d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-photo/img/large_360x360_icon.png
// module id = 755
// module chunks = 0